/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPauseCuteFi: {
  name: 'pause-cute-fi';
  data: string;
} = {
  name: 'pause-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.58 3.047c-.733.14-1.4.821-1.537 1.57-.061.334-.061 14.432 0 14.766.147.802.829 1.456 1.652 1.584 1.051.163 2.073-.553 2.262-1.584.061-.334.061-14.432 0-14.766-.141-.768-.806-1.433-1.574-1.574a2.106 2.106 0 0 0-.803.004m8 0c-.733.14-1.4.821-1.537 1.57-.061.334-.061 14.432 0 14.766.147.802.829 1.456 1.652 1.584 1.051.163 2.073-.553 2.262-1.584.061-.334.061-14.432 0-14.766-.141-.768-.806-1.433-1.574-1.574a2.106 2.106 0 0 0-.803.004"/></svg>`
};
